module.exports = __webpack_public_path__ + "img/tu04.9ef6498e.png";